export class URLHelper {
    static getBaseURL(): string {
        return location.protocol + "//" + location.hostname;
        // return "https://rehau-free.cidaas.de";
        // return "https://nightlybuild.cidaas.de";
    }
}